import { useState, useEffect, useCallback, useMemo } from 'react'
import { getJugadoresInscritos } from '../lib/supabase'

// Quien participa en la temporada seleccionada.
//
// Las pantallas con selector de temporada listaban a TODOS los jugadores de la
// org y usaban la temporada solo para acotar cargos/entregas -- o sea, el filtro
// por temporada no filtraba el padron. Este hook es la fuente unica de "quien
// esta inscrito" para todas ellas.
//
// VALVULA (importante): si la temporada no tiene NINGUN inscrito, no se filtra
// nada. El reset de julio (20260716_inscripciones_reset) dejo clubes en cero; sin
// esta valvula sus pantallas se vaciarian de golpe y pareceria perdida de datos.
// El filtro solo muerde cuando el club ya empezo a usar Inscripciones.
//
// Falla ABIERTA: si la consulta truena, tampoco se filtra. Esconder gente por un
// error de red seria peor que mostrar de mas.
export const useInscritosTemporada = (temporadaId) => {
  const [inscritos, setInscritos] = useState(null)
  const [error, setError] = useState(false)
  const [verNoInscritos, setVerNoInscritos] = useState(false)

  useEffect(() => {
    let vivo = true
    setInscritos(null)
    setError(false)
    if (!temporadaId) return undefined
    getJugadoresInscritos(temporadaId)
      .then((ids) => { if (vivo) setInscritos(new Set(ids)) })
      .catch(() => { if (vivo) { setInscritos(new Set()); setError(true) } })
    return () => { vivo = false }
  }, [temporadaId])

  const cargando = inscritos === null
  const hayPadron = !!inscritos && inscritos.size > 0
  // Se filtra solo si hay padron y el usuario no pidio ver a los demas.
  const filtrando = hayPadron && !verNoInscritos

  const esInscrito = useCallback(
    (jugadorId) => !!inscritos && inscritos.has(jugadorId),
    [inscritos],
  )

  // `getId` saca el jugador_id de cada elemento (default: el propio .id).
  const filtrar = useCallback(
    (lista = [], getId = (x) => x?.id) =>
      (filtrando ? lista.filter((x) => inscritos.has(getId(x))) : lista),
    [filtrando, inscritos],
  )

  return useMemo(() => ({
    inscritos,
    cargando,
    hayPadron,
    filtrando,
    // Temporada sin un solo inscrito: hay que avisarlo, no es lo mismo que un error.
    sinPadron: !cargando && !hayPadron && !error,
    error,
    verNoInscritos,
    setVerNoInscritos,
    esInscrito,
    filtrar,
  }), [inscritos, cargando, hayPadron, filtrando, error, verNoInscritos, esInscrito, filtrar])
}

export default useInscritosTemporada
